// This is the PublicationLimitsCard.logic.ts sibling that canon/logic-in-tsx
// requires for the non-JSX helpers pulled out of PublicationLimitsCard.tsx.
// That rule strips only the text before the first dot ("PublicationLimitsCard")
// and expects an export of that exact name; no multi-helper logic module will
// ever have one, and canonicalNamePatterns has no carve-out for the `.logic`
// suffix (unlike the `use[A-Z]` hook pattern it already recognizes).
/* eslint-disable canon/file-name-matches-primary-export -- see comment above: no export here can be named after the file's pre-dot stem by construction */
import type { PublicationLimitsData, PublicationLimitsState } from "./usePublicationLimits";

// Last committed limits regardless of state: the loaded/saving values, the
// state.lastData carried by an error, or null before anything ever loaded.
export function committedData(state: PublicationLimitsState): PublicationLimitsData | null {
  let data: PublicationLimitsData | null;
  if (state.kind === "data" || state.kind === "saving") {
    data = {
      articleMaxPosts: state.articleMaxPosts,
      sentenceMaxPosts: state.sentenceMaxPosts,
      updatedAt: state.updatedAt,
      updatedByName: state.updatedByName,
    };
  } else if (state.kind === "error") {
    data = state.lastData;
  } else {
    data = null;
  }
  return data;
}

export function validateLimitInput(raw: string): string | undefined {
  const parsed = Number(raw);
  const isValid = raw.trim() !== "" && Number.isInteger(parsed) && parsed >= 1;
  return isValid ? undefined : "Введите целое число не меньше 1";
}

export function formatUpdatedAt(updatedAt: string): string {
  return new Date(updatedAt).toLocaleString("ru-RU");
}
